export default __webpack_public_path__ + "static/media/dashboard.44d95332.svg";